import { Card, Col, Container, Row } from 'reactstrap'
import { MasonryGalleryDescriptionCap } from '../../../../Utils/Constants'
import MasonryGalleryWithDescCardBody from './MasonryGalleryWithDescCardBody'
import CardHeaderCommon from '../../../../Utils/CommonComponents/CardHeaderCommon'

const MasonryImageDescContainer = () => {
  return (
    <Container fluid>
      <Row>
        <Col sm="12" className="box-col-12">
          <Card>
            <CardHeaderCommon title={MasonryGalleryDescriptionCap} />
            <MasonryGalleryWithDescCardBody />
          </Card>
        </Col>
      </Row>
    </Container>
  )
}

export default MasonryImageDescContainer